// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'Open Sans', 'Open Sans Fallback'","fontStyle":"normal"},"className":"__className_3f7a4f","variable":"__variable_3f7a4f"};